/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormatIndentDecreaseOutlinedIcon from "@mui/icons-material/FormatIndentDecreaseOutlined";
import FormatIndentIncreaseOutlinedIcon from "@mui/icons-material/FormatIndentIncreaseOutlined";
import { css } from "aphrodite";
import BellIcon from "../../assets/svg/Bell";
import Logo from "../../assets/svg/Logo";
import { selectChiefLocByUserRole } from "../../redux/selectors/user";
import Api from "../../services/api/introductionForm";
import { ROUTES } from "../../utils/constants";
import CustomTypography from "../common/new/Typography/Typography";
import { getInitials } from "../../pages/member/memberDetails/utlis";
import Styles from "./styles";
import SimpleModal from "./SimpleModal";
import Style from "./Header.styles";
import { checkForceLogout } from "../../config/sessionKill";
import ForceLogout from "../../services/api/ForceLogout";

const checkChangeToNewScreenPath = (originalPath, currentPath, id) =>
  originalPath === `/${currentPath?.split("/:")?.[0]}/${id}`;
const checkTypeScreenPath = (originalPath, currentPath, type) =>
  originalPath === `/${currentPath?.split("/:")?.[0]}/${type}`;
const checkTypeAndChangeToNewScreenPath = (
  originalPath,
  currentPath,
  type,
  id
) => originalPath === `/${currentPath?.split("/:")?.[0]}/${type}/${id}`;
const removeSlashFromBeg = (originalPath) =>
  originalPath && originalPath[0] === "/"
    ? originalPath.slice(1)
    : originalPath;

function ResponsiveAppBar({ open, handleDrawerToggle }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [profile, setProfile] = React.useState({});
  const { id, type } = useParams();
  const chiefLocation = useSelector(selectChiefLocByUserRole);
  const [showModal, setShowModal] = React.useState(false);
  const [districtIdUpdated, setDistrictIdUpdated] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const handleLogout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   dispatch({ type: "RESET_USER_STATE" });
  //   handleMenuClose();
  //   navigate("/");
  // };

  const handleLogout = async () => {
    const loginId = localStorage.getItem("loginId");

    // STEP 1 → Pehle backend ko logout update karna
    if (loginId) {
      try {
        console.log("📡 Calling backend logout API...");

        const response = await ForceLogout.userLogout(loginId);

        console.log("🟢 Logout API Response:", response);

        if (response?.status === 200 || response?.data?.code === 200) {
          console.log("🟢 Backend logout status updated successfully");
        } else {
          console.warn("⚠ Unexpected backend response", response);
        }
      } catch (err) {
        localStorage.clear();
        sessionStorage.clear();
        dispatch({ type: "RESET_USER_STATE" });
        handleMenuClose();

        navigate("/");
        console.error("🔥 Logout API error:", err);
        // ❌ Backend update fail → frontend logout mat karo
        return;
      }
    }

    // STEP 2 → API success ke baad hi local logout
    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: "RESET_USER_STATE" });
    handleMenuClose();

    navigate("/");
  };

  const getUserData = async () => {
    // const isPageRefresh = window.performance.navigation.type === 1;
    const isHomePage = location.pathname === "/";
    const hasShownRolePopup = localStorage.getItem("rolePopupShown");

    try {
      const response = await Api.getProfileData();

      const now = new Date();
      const formattedTime = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}-${String(
        now.getHours()
      ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
        now.getSeconds()
      ).padStart(2, "0")}`;
      if (response?.data?.areaId) {
        localStorage.setItem("memberId", response.data.memberId);
        localStorage.setItem("areaId", response.data.areaId);
        localStorage.setItem("zoneId", response.data.zoneId);
        localStorage.setItem("regionId", response.data.regionId);
        localStorage.setItem("chapterId", response.data.chapterId);
        localStorage.setItem("districtId", response.data.districtId);
        // Extract the first position (e.g. "Region Chief")
        const positionFull = response.data.positions?.[0] || "";

        // Extract only the first word (e.g. "Region")
        const position = positionFull.split(" ")[0];

        // Store it in localStorage
        localStorage.setItem("positionRole", position);
        localStorage.setItem("LoginTime", formattedTime);
        // Store UnitName based on position
        let unitName = "";

        switch (position) {
          case "Area":
            unitName = response.data.areaName;
            break;
          case "Zone":
            unitName = response.data.zoneName;
            break;
          case "Region":
            unitName = response.data.regionName;
            break;
          case "Chapter":
            unitName = response.data.chapterName;
            break;
          case "District":
            unitName = response.data.districtName;
            break;
          default:
            unitName = "";
        }

        localStorage.setItem("UnitName", unitName);
      }
      checkForceLogout();

      dispatch({
        type: "SET_USER_PROFILE",
        payload: response,
      });

      setProfile(response.data);

      // if (isPageRefresh) {
      //   setShowModal(false);
      // } else {
      //   const shouldShowModal =
      //     response.data?.proxyProfile?.additionalRoles?.length > 0;
      //   setShowModal(shouldShowModal);
      // }
      // if (!isPageRefresh && !hasShownRolePopup) {
      //   const shouldShowModal =
      //     response.data?.proxyProfile?.additionalRoles?.length > 0;

      //   if (shouldShowModal) {
      //     setShowModal(true);
      //     localStorage.setItem("rolePopupShown", "true");
      //   }
      // }
      const shouldShowModal =
        isHomePage &&
        !hasShownRolePopup &&
        response.data?.proxyProfile?.additionalRoles?.length > 0;

      if (shouldShowModal) {
        setShowModal(true);
        localStorage.setItem("rolePopupShown", "true");
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  React.useEffect(() => {
    getUserData();
  }, []);

  const getHeaderTitle = () => {
    let headerTitle = "";
    Object.keys(ROUTES).forEach((route) => {
      const currentPath = removeSlashFromBeg(ROUTES[route].path);
      if (
        location.pathname === `/${currentPath}` ||
        checkChangeToNewScreenPath(location.pathname, currentPath, id) ||
        checkTypeScreenPath(location.pathname, currentPath, type) ||
        (checkTypeAndChangeToNewScreenPath(
          location.pathname,
          currentPath,
          type,
          id
        ) &&
          ROUTES[route].headerTitle)
      ) {
        headerTitle = ROUTES[route].headerTitle;
      }
    });
    return headerTitle;
  };

  const onLogoClick = () => {
    navigate("/");
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <AppBar position="static" className={css(Style.appBarStyle)}>
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          paddingLeft: "34px",
          paddingRight: "34px",
        }}
      >
        {/* Mobile: Always show IconButton (original behavior) */}
        {isMobile && (
          <IconButton
            sx={{
              ...Styles.menuBarIcon,
              marginLeft: isMobile ? "30px" : "30px", // Original positioning
            }}
            onClick={handleDrawerToggle}
          >
            {open ? (
              <FormatIndentDecreaseOutlinedIcon />
            ) : (
              <FormatIndentIncreaseOutlinedIcon />
            )}
          </IconButton>
        )}

        {/* Desktop: Conditional Logo/IconButton */}
        {!isMobile && !open && (
          <Logo
            onClick={onLogoClick}
            style={{
              cursor: "pointer",
              width: "60px",
              height: "auto",
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1000,
            }}
          />
        )}

        {!isMobile && open && (
          <IconButton
            sx={{
              ...Styles.menuBarIcon,
              marginLeft: "30px", // Original positioning
            }}
            onClick={handleDrawerToggle}
          >
            <FormatIndentDecreaseOutlinedIcon />
          </IconButton>
        )}

        <Toolbar disableGutters>
          <Typography className={css(Style.headerTitle)} noWrap>
            {!isMobile && getHeaderTitle()}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />

          <Box className={css(Style.right)}>
            <BellIcon />

            <Box className={css(Style.userIcon)} onClick={handleMenuClick}>
              {profile.profilePhotoUrl ? (
                <img
                  src={profile.profilePhotoUrl}
                  alt="Profile"
                  style={Styles.profilePhoto}
                  width="100"
                  height="100"
                />
              ) : (
                <div style={Styles.userInitialsStyle}>
                  {getInitials(profile.fullName)}
                </div>
              )}
              <div style={Styles.circle} />
            </Box>

            <Box>
              <Typography
                sx={{ color: "#1a237e", fontSize: 14, fontWeight: 700 }}
              >
                {profile.fullName}
              </Typography>
              <Typography
                sx={{ color: "#510404", fontSize: 12, fontWeight: 400 }}
              >
                {profile?.positions?.[0]}
              </Typography>
              <Box maxWidth="250px" overflow="hidden" textOverflow="ellipsis">
                <CustomTypography
                  sx={{
                    background: "#043d90",
                    color: "white",
                    fontSize: 11,
                    fontWeight: 500,
                    textTransform: "capitalize",
                    padding: "2px",
                  }}
                >
                  {chiefLocation}
                </CustomTypography>
              </Box>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                elevation: 4,
                sx: {
                  mt: 1.5,
                  minWidth: 180,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  "& .MuiMenuItem-root": {
                    fontSize: 14,
                    fontWeight: 500,
                    py: 1.2,
                    px: 2.5,
                    gap: 1,
                    transition: "background 0.2s ease",
                    "&:hover": {
                      bgcolor: "rgba(0,0,0,0.04)",
                    },
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  const memberId = profile?.memberId;

                  if (memberId) {
                    navigate(`/member/details/${memberId}`);
                  } else {
                    console.error("No memberId found in profile data");
                  }
                }}
              >
                <ListItemIcon>
                  <AccountCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="View Profile" />
              </MenuItem>

              {profile?.proxyProfile?.additionalRoles?.length > 0 && (
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    setShowModal(true);
                    setDistrictIdUpdated(false);
                  }}
                >
                  <ListItemIcon>
                    <CompareArrowsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Switch Role" />
                </MenuItem>
              )}

              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>

        <SimpleModal
          open={showModal}
          label="How do you want to login?"
          profile={profile}
          getUserData={getUserData}
          districtIdUpdated={districtIdUpdated}
          setDistrictIdUpdated={setDistrictIdUpdated}
          setShowModal={setShowModal}
        />
      </Container>
    </AppBar>
  );
}

ResponsiveAppBar.propTypes = {
  open: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default ResponsiveAppBar;
